module.exports = __webpack_public_path__ + "static/media/10-rectangle-dirty.4a8e54bb.svg";